import React from "react";
import { Link } from "react-router-dom";
import { CalendarClock } from "lucide-react";

const TONE = {
  Overdue: "bg-rose-500/15 text-rose-300 border-rose-500/30",
  "Due today": "bg-amber-500/15 text-amber-300 border-amber-500/30",
  "This week": "bg-violet-500/15 text-violet-300 border-violet-500/30",
};
const fmt = (n) => Number(n).toLocaleString("en-PH", { minimumFractionDigits: 2 });

export function DueChecksPanel({ list }) {
  const total = list.reduce((s, c) => s + c.amount, 0);
  return (
    <div data-testid="due-checks-panel" className="rounded-lg p-5 border border-violet-500/40 bg-violet-950/20">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
        <h2 className="font-display text-xl font-bold text-violet-100 flex items-center gap-2"><CalendarClock size={18} /> Post-dated checks due this week</h2>
        <span data-testid="due-checks-total" className="font-mono-ops text-sm text-slate-300">{list.length} · {fmt(total)}</span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-2">
        {list.map((c) => (
          <Link key={c.id} to="/finance?tab=check-vouchers" data-testid={`due-check-${c.number}`}
                className="block bg-slate-950/60 border border-violet-500/30 rounded-md p-3 hover:border-violet-400 transition-colors">
            <div className="flex justify-between gap-2"><span className="text-sm text-slate-200 truncate">{c.payee}</span>
              <span className="font-mono-ops text-sm text-slate-200">{fmt(c.amount)}</span></div>
            <div className="flex justify-between items-center gap-2 mt-1">
              <span className="text-xs text-slate-400 truncate">{c.bank} #{c.check_number} · {c.date.slice(0, 10)}</span>
              <span className={`shrink-0 text-[10px] uppercase tracking-widest px-1.5 py-0.5 rounded border ${TONE[c.due_status]}`}>{c.due_status}</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
